// extracted by css-extract-rspack-plugin
export default {"root":"_1LEZ5","hint":"jaFlsx"};